import React from 'react';
import cn from 'classnames';

import { BettingWidgets } from 'app-constants';
import { useWidgetSettings } from 'hooks';
import UserDevice from 'services/user-device';
import useTheater from './useTheater';

import './theater.scss';

interface Props {
    isFullscreenActive: boolean;
    header: React.ReactNode;
    children: React.ReactNode;
    isPinned: boolean;
}

const Theater: React.FC<Props> = ({
    isFullscreenActive,
    header,
    children,
    isPinned,
}) => {
    const { height, containerRef, isSmallMedium } = useTheater({
        isFullscreenActive,
        isPinned,
    });

    const { ignoreOffsetInTheaterMode } = useWidgetSettings({
        widget: BettingWidgets.STREAM,
    });

    return (
        <div
            styleName={cn('container', {
                'is-active': isFullscreenActive,
                'is-mobile': UserDevice.getInstance()?.isDeviceMobile(),
                'is-offset-ignored-in-full-screen': ignoreOffsetInTheaterMode,
                'is-header-ignored': isSmallMedium,
            })}
            className={cn('__app-Theater-container', {
                '__app-Theater-container-active': isFullscreenActive,
            })}
            style={{
                height: height && isPinned && !isFullscreenActive ? `0` : '',
            }}
        >
            {header && header}

            <div
                styleName="body"
                style={{ height: height && isPinned ? `${height}px` : '0' }}
                ref={containerRef}
                className="__app-Theater-body"
            >
                {children}
            </div>
        </div>
    );
};

export default Theater;
